import styled from 'styled-components'
import {device} from '../../../theme'

export const ExtraFeaturesWrap = styled.section `
    padding-top: 100px;
    padding-bottom: 100px;
    @media ${device.small}{
        padding-top: 60px;
        padding-bottom: 60px;
    }
`;